import { render, staticRenderFns } from "./Skills.vue?vue&type=template&id=462d20e2&"
import script from "./Skills.vue?vue&type=script&lang=js&"
export * from "./Skills.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports